import { render, staticRenderFns } from "./chikenLauncher.vue?vue&type=template&id=549252aa&"
import script from "./chikenLauncher.vue?vue&type=script&lang=ts&"
export * from "./chikenLauncher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports